<template>
  <div class="pt-2">
      <DxDataGrid
          :show-row-lines="true"
          :show-column-lines="true"
          :show-borders="true"
          :row-alternation-enabled="true"
          :rtl-enabled="label.direction === 'rtl' ? true : false"
          :data-source="banners"
          :columns="bannerFields"
          :remote-operations="true"
          :column-auto-width="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          column-resizing-mode="widget"
          :hover-state-enabled="true"
          :noDataText="checkData"
          @toolbar-preparing="onToolbarPreparing($event)"
          key-expr="id"
          class="ps_Table"
          :height="dataGridHeight-70"
      >
        <DxSearchPanel
            :visible="true"
            :width="240"
            :placeholder="label.table.search"
        />
        <template #btnGroup>
          <div>
            <b-row>
              <b-col cols="auto" class="px-1">
                <b-button
                    variant="ps-success"
                    class="py-1 pb-2"
                    size="sm"
                    v-b-tooltip.hover
                    :title="label.buttons.newBanner"
                    @click="addBannerM"
                >
                  <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                </b-button>
              </b-col>
              <b-col cols="auto" class="px-1">
                <b-button
                    variant="ps-secondary"
                    class="py-1 pb-2"
                    size="sm"
                    v-b-tooltip.hover
                    :title="label.table.reload"
                    @click="reloadBanners"
                >
                  <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </template>
        <template #btnRGroup>
          <b-row class="btnRLanguage-wrapper" style="margin-top: -15px">
            <b-col cols="6"  v-show="contentLanguageAccess == 1">
              <label for="language" class="ps_label">
                {{label.pages.contentLanguage}}
              </label>
              <v-select
                  input-id="language"
                  :options="languages"
                  v-model="selectedLanguage"
                  :reduce="group => group.id"
                  :clearable="false"
                  class="ps_select custom-p-select"
                  @input="setLanguage"
              >
              </v-select>
            </b-col>
            <b-col cols="6" class="p-dirR-5">
              <label for="group" class="ps_label">  {{label.pages.groups}} </label>
              <v-select
                  input-id="group"
                  :options="bannerTypes"
                  v-model="bannerTypeID"
                  :reduce="group => group.id"
                  :clearable="false"
                  @input="reloadBanners"
                  class="ps_select custom-p-select"
              >
                <template #no-options>
                  {{label.pages.notFound}}
                </template>
              </v-select>
            </b-col>
          </b-row>
        </template>
        <template #radif="{data}">
          <div>
            {{ data.rowIndex + 1 }}
          </div>
        </template>
        <template #image="{data}">
          <div>
            <img :src="data.data.imageAddress" class="ps_table_inside_img"/>
          </div>
        </template>
        <template #actions="{data}">
          <b-row class="justify-content-center">
            <b-col cols="auto" class="px-0">
              <button
                  @click="editBannerM(data)"
                  :id="'editBtnTlp-' + data.data.id"
              >
                <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
              </button>
              <b-tooltip
                boundary="#app"
                noninteractive
                triggers="hover"
                :target="'editBtnTlp-' + data.data.id"
              >
                {{ label.buttons.edit }}
              </b-tooltip>
            </b-col>
            <b-col cols="auto" class="px-0 pe-2">
              <button
                  @click="delBannerConfirm(data)"
                  :id="'deleteBtnTlp-' + data.data.id"
              >
                <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
              </button>
              <b-tooltip
                boundary="#app"
                noninteractive
                triggers="hover"
                :target="'deleteBtnTlp-' + data.data.id"
              >
                {{ label.buttons.delete }}
              </b-tooltip>
            </b-col>
          </b-row>
        </template>
        <DxLoadPanel :enabled="true"/>
        <DxScrolling mode="virtual"/>
      </DxDataGrid>

    <!--  Add Banner Modal -->
    <b-modal
        :dir="label.direction"
        v-model="addBannerModal"
        header-bg-variant="ps-success"
        centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.buttons.newBanner}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="addBannerModal=false"
            v-b-tooltip.hover
            :title="label.buttons.closeModal"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col sm="3">
            <label for="bannerTitle" class="ps_label">{{label.pages.title}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="bannerTitle" size="sm" v-model="bannerForm.title"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="priority" class="ps_label">{{label.pages.priority}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="priority" size="sm" type="number" v-model="bannerForm.priority"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="bannerLink" class="ps_label">{{label.pages.description}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea rows="4" id="bannerLink" size="sm" v-model="bannerForm.description"/>
          </b-col>
        </b-row>
        <b-row v-if="dropZoneAction" class="my-3">
          <b-col sm="3">
            <label for="image" class="ps_label">{{label.pages.photo}}</label>
          </b-col>
          <b-col sm="auto">
            <drop-zone-custom
                mode="image"
                :isRequired="true"
                :add="dropZoneAction"
                :edit="!dropZoneAction"
                :editSrc="bannerForm.imageAddress"
            />
          </b-col>
        </b-row>
        <b-row v-if="!dropZoneAction" class="my-3">
          <b-col sm="12">
            <drop-zone-custom
              mode="image"
              :isRequired="true"
              :add="dropZoneAction"
              :edit="!dropZoneAction"
              :editSrc="bannerForm.imageAddress"
            />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="bannerDisplay" class="ps_label">
              {{label.form.display}}
            </label>
          </b-col>
          <b-col sm="9">
            <label class="ps-switch">
              <input type="checkbox" v-model="bannerForm.isConfirm">
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="addBannerModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1"
                @click="addBanner"
            >
            {{label.buttons.submit}}
            </b-button>
            <b-button
                v-else
                variant="ps-success"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- edit Banner Modal -->
    <b-modal
        :dir="label.direction"
        v-model="editBannerModal"
        header-bg-variant="ps-warning"
        centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
           {{label.pages.editBanner}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="editBannerModal=false"
            v-b-tooltip.hover
            :title="label.buttons.closeModal"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col sm="3">
            <label for="bannerTitle" class="ps_label">{{label.pages.title}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="bannerTitle" size="sm" v-model="bannerForm.title"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="priority" class="ps_label">{{label.pages.priority}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="priority" size="sm" type="number" v-model="bannerForm.priority"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="bannerLink" class="ps_label">{{label.pages.description}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea rows="4" id="bannerLink" size="sm" v-model="bannerForm.description"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="12">
            <drop-zone-custom v-if="refreshImage" mode="image" :isRequired="true" :edit="true" :editSrc="bannerForm.imageAddress" />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="bannerDisplay" class="ps_label">
              {{label.form.display}}
            </label>
          </b-col>
          <b-col sm="9">
            <label class="ps-switch">
              <input type="checkbox" v-model="bannerForm.isConfirm">
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="editBannerModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-warning"
                size="sm"
                class="mx-1"
                @click="editBanner"
            >
            {{label.buttons.saveChanges}}
            </b-button>
            <b-button
                v-else
                variant="ps-warning"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Banner Confirm Modal -->
    <b-modal
        :dir="label.direction"
        v-model="delBannerModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteConfirm}}
            <br/>
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delBannerModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deleteBanner"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
    mb-0   </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import alert from '@/plugins/AlertMessages.js';
import dropZoneCustom from '@/components/DropZoneCustom'
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: "BannersTab",
  mixins: [dataGridMixin, contentLanguage],
  components: {
    dropZoneCustom
  },
  data() {
    return {
      refreshImage: true,
      dropZoneAction: true,
      bannerTypeID: null,
      file: null,
      label,

      delId: null,
      delTitle: '',

      bannerFields: [
        {
          cellTemplate: 'radif',
          caption: label.table.row,
          allowSorting: false,
          allowFiltering: false,
          width: '100',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'actions',
          caption: label.table.actions,
          allowSorting: false,
          allowFiltering: false,
          width: '150',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'image',
          caption: label.table.image,
          allowSorting: false,
          allowFiltering: false,
          width: '150',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'title',
          caption: label.table.title,
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'description',
          caption: label.table.description,
          dataType: 'string',
          width: '400',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'priority',
          caption: label.table.priority,
          dataType: 'int',
          width: '100',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'isConfirm',
          caption: label.table.status,
          dataType: 'boolean',
          cssClass: 'text-center align-middle'
        },
      ],
      addBannerModal: false,
      bannerForm: {
        title: '',
        description: '',
        isConfirm: true,
        imageName: '',
        imageAddress: null,
        priority: null
      },
      editBannerModal: false,
      delBannerModal: false,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      banners: 'baseX/banners',
      bannerTypes: 'baseX/bannerTypes',
      loadingBtn: 'loadingBtn',
      imageUrl: 'imageUrl',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.editModal = false;
        this.addBannerModal = false;
        this.editBannerModal = false;
        this.delBannerModal = false;
        this.reloadBanners();
        this.reloadFields();
      }
    },
    bannerTypes() {
      this.bannerTypeID = this.bannerTypes[0].id;
      this.reloadBanners()
    },
    imageUrl() {
      if (this.imageUrl && this.imageUrl.length > 0) {
        this.refreshImage = false
        this.dropZoneAction = false
        this.bannerForm.imageName = this.imageUrl[0].fullPath
        this.bannerForm.imageAddress = this.imageUrl[0].fileAddress
        this.$nextTick(() => {
          this.refreshImage = true
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
  },
  methods: {
    addBannerM() {
      this.reloadFields();
      this.dropZoneAction = true;
      this.$store.commit("setUrlsEmpty");
      this.addBannerModal = true;
    },
    addBanner() {
      this.$store.commit("setLoadingBtn", true);
      let formData = new FormData();
      if (this.bannerTypeID != null) {
        formData.append('BannerTypeId', this.bannerTypeID);
      }
      if (this.bannerForm.title != null) {
        formData.append('Title', this.bannerForm.title);
      }
      if (this.bannerForm.description != null) {
        formData.append('Description', this.bannerForm.description);
      }
      if (this.bannerForm.isConfirm != null) {
        formData.append('IsConfirm', this.bannerForm.isConfirm);
      }
      if (this.bannerForm.imageName != null) {
        formData.append('ImageName', this.bannerForm.imageName);
      }
      if (this.bannerForm.priority != null) {
        formData.append('Priority', this.bannerForm.priority);
      }
      if(this.bannerForm.imageName != null) {
        this.$store.dispatch('baseX/addBanner', formData);
        this.dropZoneAction = true
      } else {
        this.$store.commit("setLoadingBtn", false);
        this.$store.commit('setError', alert.error.empty)
      }
    },
    editBannerM(item) {
      this.editId = item.data.id;
      this.bannerForm = {
        title: item.data.title,
        description: item.data.description,
        isConfirm: item.data.isConfirm,
        imageName: item.data.imageName,
        imageAddress: item.data.imageAddress,
        priority: item.data.priority,
      };
      this.editBannerModal = true;
    },
    editBanner() {
      this.$store.commit("setLoadingBtn", true);
      let formData = new FormData();
      if (this.bannerTypeID != null) {
        formData.append('BannerTypeId', this.bannerTypeID);
      }
      if (this.bannerForm.title != null) {
        formData.append('Title', this.bannerForm.title);
      }
      if (this.bannerForm.description != null) {
        formData.append('Description', this.bannerForm.description);
      }
      if (this.bannerForm.isConfirm != null) {
        formData.append('IsConfirm', this.bannerForm.isConfirm);
      }
      if (this.bannerForm.imageName != null) {
        formData.append('ImageName', this.bannerForm.imageName);
      }
      if (this.bannerForm.priority != null) {
        formData.append('Priority', this.bannerForm.priority);
      }
      const values = {
        id: this.editId,
        value: formData
      };
      this.$store.dispatch('baseX/editBanner', values);
    },
    delBannerConfirm(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.title;
      this.delBannerModal = true;
    },
    deleteBanner() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/deleteBanner', this.delId);
    },
    reloadFields() {
      this.bannerForm = {
        title: '',
        description: '',
        isConfirm: true,
        imageName: '',
        imageAddress: null,
        priority: null,
      };
      this.file = null;
      this.$store.commit("setLoadingBtn", false);
    },
    reloadBanners() {
      this.$store.dispatch('baseX/getBanners', this.bannerTypeID);
    },
    reloadContent() {
      this.$store.dispatch('baseX/getBannerTypes', this.selectedLanguage);
      this.reloadBanners();
    },
  },
  mounted() {
    this.$store.dispatch('baseX/getBannerTypes', this.selectedLanguage);
  },
}
</script>

<style>
.custom-p-select {
  width: 170px;
}
</style>
